"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.widgetAdderBlacklist = exports.WidgetAdderOptions = exports.getWidgetAdderOptions = exports.shouldOpenMenu = exports.getCustomWidgetAdderClasses = exports.getCustomLeftOffset = exports.getTopPosition = void 0;
var slate_1 = require("slate");
var EditorTypes_1 = require("../../EditorTypes");
var Utils_1 = require("Project/QwilrEditor/Utils");
var slate_react_1 = require("slate-react");
var Types_1 = require("@CommonFrontendBackend/ContentTokens/Types");
var lodash_1 = require("lodash");
var EditorWidgetRegistry_1 = require("Project/QwilrEditor/WidgetRegistry/EditorWidgetRegistry");
var LEFT_MARGIN = 11;
var TOP_OFFSET = 3;
var getTopPosition = function (editor, editorElem, adderElem, leftOffset) {
    var selection = editor.selection;
    var startBlockEntry = (0, Utils_1.getStartBlock)(editor);
    var container = editorElem.getBoundingClientRect();
    var adderRect = adderElem.getBoundingClientRect();
    var goodSelection = selection && slate_react_1.ReactEditor.isFocused(editor) && slate_1.Range.isCollapsed(selection);
    var shouldDisplayWidgetAdderOnCurrentSelection = goodSelection &&
        !!startBlockEntry &&
        isParentBlockValid(editor, startBlockEntry) &&
        (slate_1.Editor.isEmpty(editor, startBlockEntry[0]) || hasWidgetAddingText(slate_1.Node.string(startBlockEntry[0])));
    if (shouldDisplayWidgetAdderOnCurrentSelection) {
        var nativeRange = slate_react_1.ReactEditor.toDOMRange(editor, selection);
        var selectionRect = nativeRange.startContainer.parentElement.getBoundingClientRect();
        var centering = selectionRect.height / 2 - adderRect.height / 2;
        return {
            position: EditorTypes_1.WidgetAdderPosition.Selection,
            top: selectionRect.top - container.top + centering,
            left: selectionRect.left - container.left - adderRect.height - LEFT_MARGIN - leftOffset,
            text: slate_1.Node.string(startBlockEntry[0]),
        };
    }
    var nodes = Array.from(slate_1.Editor.nodes(editor, { match: function (node) { return !slate_1.Text.isText(node); }, reverse: true, at: [] }));
    var isLastNodeEntryInEditor = nodes[1];
    var isLastNodeInEditor = isLastNodeEntryInEditor[0];
    var isLastNodeIsParagraphAndEmpty = slate_1.Element.isElement(isLastNodeInEditor) &&
        isLastNodeInEditor.type === "paragraph" &&
        slate_1.Node.string(isLastNodeInEditor).length === 0;
    if (isLastNodeIsParagraphAndEmpty) {
        var lastNativeNodeRect = slate_react_1.ReactEditor.toDOMNode(editor, isLastNodeInEditor).getBoundingClientRect();
        var centering = lastNativeNodeRect.height / 2 - adderRect.height / 2;
        return {
            position: EditorTypes_1.WidgetAdderPosition.LastLine,
            top: lastNativeNodeRect.top - container.top + centering,
            left: -adderRect.height - LEFT_MARGIN,
            text: "",
        };
    }
    return {
        position: EditorTypes_1.WidgetAdderPosition.AfterLastLine,
        top: container.height - adderRect.height + TOP_OFFSET,
        left: -adderRect.height - LEFT_MARGIN,
        text: "",
    };
};
exports.getTopPosition = getTopPosition;
var getCustomLeftOffset = function (editor) {
    if ((0, Utils_1.isInsideAccordion)(editor)) {
        return 0;
    }
    if ((0, Utils_1.isInsideAgreement)(editor)) {
        return 0;
    }
    return undefined;
};
exports.getCustomLeftOffset = getCustomLeftOffset;
var getCustomWidgetAdderClasses = function (editor) {
    if ((0, Utils_1.isInsideAccordionBody)(editor)) {
        return "widget-adder__placeholder--inside-accordion-body";
    }
    return undefined;
};
exports.getCustomWidgetAdderClasses = getCustomWidgetAdderClasses;
var shouldOpenMenu = function (editor) {
    var selection = editor.selection;
    var startBlockEntry = (0, Utils_1.getStartBlock)(editor);
    if (startBlockEntry) {
        return (!!selection &&
            slate_1.Range.isCollapsed(selection) &&
            slate_react_1.ReactEditor.isFocused(editor) &&
            isParentBlockValid(editor, startBlockEntry) &&
            hasWidgetAddingText(slate_1.Node.string(startBlockEntry[0])));
    }
    else {
        return false;
    }
};
exports.shouldOpenMenu = shouldOpenMenu;
var getWidgetAdderOptions = function (context) {
    var filterText = context.filterText, inSideBySide = context.inSideBySide, inContentLoop = context.inContentLoop, inAccordionBody = context.inAccordionBody, usingFeature = context.usingFeature;
    if (!filterText.startsWith("+")) {
        return [];
    }
    var filterTextWithoutPlus = filterText.replace(/^\+/, "").toLowerCase();
    return (0, lodash_1.sortBy)(exports.WidgetAdderOptions, function (option) {
        var index = widgetAdderOrdering.findIndex(function (sortId) { return option.type === sortId; });
        if (index === -1) {
            return 1000;
        }
        return index;
    }).filter(function (_a) {
        var type = _a.type, tags = _a.tags;
        if (!type.startsWith(filterTextWithoutPlus) && !tags.find(function (tag) { return tag.startsWith(filterTextWithoutPlus); })) {
            return false;
        }
        var widgetConfig = (0, EditorWidgetRegistry_1.getGenericConfigByType)(type);
        var registrySourcedOption = widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.widgetAdderConfig;
        if (registrySourcedOption) {
            if (inSideBySide && !widgetConfig.validContainers.includes("sideBySideColumn")) {
                return false;
            }
            if (inAccordionBody && !widgetConfig.validContainers.includes("accordionBody")) {
                return false;
            }
            if (inContentLoop && !widgetConfig.validContainers.includes("contentLoopBody")) {
                return false;
            }
            if (widgetConfig.requiresTokenAvailability && !context.tokensAvailable) {
                return false;
            }
            var requiresFeatures = registrySourcedOption.requiresFeatures;
            if (!requiresFeatures) {
                return true;
            }
            return requiresFeatures.every(function (f) { return usingFeature(f); });
        }
        var canUseSideBySide = !inSideBySide;
        if (type === Types_1.WidgetBlockType.SideBySide && (!canUseSideBySide || inContentLoop || inAccordionBody)) {
            return false;
        }
        if (type === Types_1.WidgetBlockType.Table && (inSideBySide || inContentLoop || inAccordionBody)) {
            return false;
        }
        return true;
    });
};
exports.getWidgetAdderOptions = getWidgetAdderOptions;
var widgetAdderOrdering = [
    "image",
    Types_1.WidgetBlockType.SideBySide,
    Types_1.WidgetBlockType.Table,
    "accordion",
    "video",
    "iframe",
    "button",
    "googleMaps",
    "roiCalculator",
    "contentLoop",
    "horizontalRule",
];
exports.WidgetAdderOptions = __spreadArray([
    {
        type: Types_1.WidgetBlockType.Table,
        tags: ["rows", "cells"],
    }
], __read(EditorWidgetRegistry_1.configs
    .filter(function (c) { return !(0, lodash_1.isNil)(c.widgetAdderConfig); })
    .map(function (config) {
    var widgetAdderConfig = config.widgetAdderConfig;
    if ((0, lodash_1.isNil)(widgetAdderConfig)) {
        throw new Error("No-op");
    }
    return {
        type: config.type,
        tags: widgetAdderConfig.tags,
        icon: widgetAdderConfig.icon,
        displayName: widgetAdderConfig.displayName,
        tooltip: widgetAdderConfig.tooltip,
    };
})), false);
exports.widgetAdderBlacklist = ["quoteSummary"];
var allTags = [];
exports.WidgetAdderOptions.forEach(function (option) {
    allTags.push(option.type.toLowerCase());
    if (option.displayName) {
        allTags.push(option.displayName.toLowerCase());
    }
    allTags = allTags.concat(option.tags);
});
var hasWidgetAddingText = function (text) {
    if (text.length === 0 || !text.startsWith("+")) {
        return false;
    }
    var lowerCaseText = text.toLowerCase();
    var matchingTags = allTags.filter(function (tag) {
        return "+".concat(tag).startsWith(lowerCaseText);
    });
    return matchingTags.length > 0;
};
var isParentBlockValid = function (editor, block) {
    var _a, _b;
    var parent = slate_1.Node.parent(editor, block[1]);
    return (isContentBlock(block[0].type) &&
        (slate_1.Editor.isEditor(parent) ||
            parent.type === "sideBySideColumn" ||
            !!((_b = (_a = (0, EditorWidgetRegistry_1.getGenericConfigByType)(parent.type, true)) === null || _a === void 0 ? void 0 : _a.containerNodeConfiguration) === null || _b === void 0 ? void 0 : _b.showWidgetAdder)));
};
var isContentBlock = function (type) {
    return type === "paragraph";
};
